const secondaryNavBar = {
  displayField: 'title',
  name: 'Secondary Nav Bar',
  description: 'Nav bar that appears above the global nav bar. This nav bar is only used on some pages',
  fields: [
    {
      id: 'title',
      name: 'title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'topLevelNav',
      name: 'Top Level Nav',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'navLink' ] } ],
        linkType: 'Entry'
      }
    }
  ],
  sys: {
    id: 'secondaryNavBar',
    version: 10,
    updatedAt: '2024-04-16T14:17:46.922Z'
  }
};
export default secondaryNavBar;